<template>
	<div>
		<myheader headTitle="关于"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div style="margin: .5rem auto 1rem;text-align: center;">
						<img style="width: 3rem; height: 3rem; " src="@/assets/images/enterpriseinfo.svg">
						<div class="text14 textcolor333 margin_top_3 font_weight_bold">
							{{homeUrl?'电子签约':'石化e签'}}
						</div>
						<div class="text12 textcolor666 margin_top_5">v3.0.3</div>
					</div>
				</div>
			</div>
			<div v-if="isUpdate" style="position: fixed;left: 0;bottom: 4rem;right: 0;padding: 0 .5rem;">
				<button class="all_button22 text16" style="width: 100%;" @click="checkUpdate()">检查更新</button>
			</div>
		</div>
		<!-- <van-overlay :show="downloadShow" z-index="11">
			<div class="load_overlay">
				<div class="load_overlay_content">
					<van-circle v-model="currentRate" rate="'100'" speed="'1'" color="#0277FC" :text="downStatusText"/>
				</div>
			</div>
		</van-overlay> -->
		<div class="text12 textcolor33 all_text_center"
			style="padding: 0 10%; position: absolute;bottom: 1rem;left: 0;">
			<div>Copyright © 2025中国石油化工集团有限公司版权所有</div>
			<div>京ICP备05037230号-83A 运维电话:4009199000转3</div>
		</div>
	</div>
</template>

<script>
	//import axios from 'axios';
	import {
		Dialog
	} from 'vant';
	import {
		GETUPDATE,
	} from '../../utils/http';
	import {
		getAppVersion,
		getDeviceType,
		updateAndroidApk,
		deleteExitFile,
		jumpHarmonyAppStore,
	} from '../../utils/nativeOtherOperate.js'
	export default {
		// components: {
		// 	[Dialog.name]: Dialog,
		// },
		data() {
			return {
				//
				homeUrl: '',
				//true,//
				isUpdate: (window.plus && plus.os.name === 'Android') || this.Tool.checkIsHarmonyOS(),
				//
				downloadShow: false,
				//
				downStatusText: '下载中',
				//
				currentRate: '',
				//
				rate: '100',
			}
		},
		mounted() {
			this.homeUrl = window.localStorage.getItem("HomeUrl")
			this.isUpdate = (!this.homeUrl && window.plus && plus.os.name === 'Android') || this.Tool.checkIsHarmonyOS()
		},
		beforeDestroy() {
			this.$store.dispatch(this.$LoadText, '加载中...')
		},
		methods: {
			//
			checkUpdate() {
				if (getDeviceType() === 'harmony') {
					jumpHarmonyAppStore()
					return
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$store.dispatch(this.$LoadText, '加载中...')
				let deviceType = getDeviceType() || 'android'
				let version = getAppVersion() || '3.0.1'
				// let deviceType = 'android'
				// let version = '3.0.1'
				GETUPDATE('/api/check', {
					name: 'esign',
					deviceType: deviceType,
					version: version
				}, {
					'X-AUTHEN-KEY': 'E5E867C210F845B89A8DEDCA56E45F95',
				}).then(res => {
					if (res.success && res.data && res.data.canUpdate) {
						this.popDownloadAndroidApk(res.data.url)
					} else {
						this.$Toast('当前是最新版本！')
						this.$store.dispatch(this.$LoadShow, false)
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					console.log('check', err)
				})
				// axios.get(process.env.VUE_APP_UPDATE_URL + '/update/api/check?name=esign&deviceType=' + deviceType +
				// 		'&version=' + version, {
				// 			headers: {
				// 				'X-AUTHEN-KEY': 'E5E867C210F845B89A8DEDCA56E45F95',
				// 			}
				// 		})
				// 	.then(res => {
				// 		// 处理响应数据
				// 		if (res.data.success && res.data.data && res.data.data.canUpdate) {
				// 			// this.$Toast('当前是最新版本！')
				// 			// this.$store.dispatch(this.$LoadShow, false)
				// 			this.popDownloadAndroidApk(res.data.data.url)
				// 		} else {
				// 			this.$Toast('当前是最新版本！')
				// 			this.$store.dispatch(this.$LoadShow, false)
				// 		}
				// 	})
				// 	.catch(error => {
				// 		this.$store.dispatch(this.$LoadShow, false)
				// 		console.log('check', error)
				// 	});
			},
			//
			popDownloadAndroidApk(url) {
				let that = this
				Dialog.confirm({
						title: '提示',
						message: '存在比当前版本高的升级版本，点击确定开始下载，下载后进行升级。',
						confirmButtonText: '确定',
						confirmButtonColor: '#0277FC'
					})
					.then(() => {
						that.downloadAndroidApk(url)
					})
					.catch(() => {
						this.$store.dispatch(this.$LoadShow, false)
					});
			},
			//
			downloadAndroidApk(url) {
				let time = Date.now()
				let that = this
				let fileName = '_downloads/update_' + time + '.apk'
				let aFileName = 'downloads/update_' + time + '.apk'
				this.$store.dispatch(this.$LoadText, '下载中...')
				let task = plus.downloader.createDownload(url, {
					filename: fileName,
				}, function(d, status) {
					//console.log('downloadAndroidApk--=',d,status)
					that.$store.dispatch(that.$LoadShow, false)
					if (status === 200) {
						if (!updateAndroidApk(aFileName)) {
							that.$Toast('安装包升级失败，请重试！')
						}
					} else {
						that.$Toast('下载安装包失败，请重试！')
					}
				})
				//task.setRequestHeader('','');
				task.start()
				//另一种方式
				/*axios.get(url, {
					responseType: 'blob',
					timeout: 60000,
				}).then(res => {
					console.log(res)
					this.saveFile(res.data)
				}).catch(err => {
				})*/
			},
			//
			saveFile(blobData) {
				plus.io.requestFileSystem(
					plus.io.PRIVATE_WWW, (fs) => {
						fs.root.getFile('update.apk', {
								create: true
							},
							(fileEntry) => {
								fileEntry.createWriter((writer) => {
									writer.onwriteend = (e) => {
										console.log('文件保存成功', e)
									}
									writer.onerror = (e) => {
										console.log('文件保存失败', e)
									}
									writer.write(blobData)
								}, (error) => {
									console.log('创建文件写入器失败', error)
								})
							}, (error) => {
								console.log('获取文件失败', error)
							})
					}, (error) => {
						console.log('读取文件系统失败', error)
					})
			}
		},
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
</style>